export default {
  alternativeCurrent: {
    id: 'product_page_carousel_alternative_current',
    defaultMessage: 'Current',
  },
  alternativeController: {
    id: 'product_page_carousel_alternative_controller',
    defaultMessage: 'Controller',
  },
  alternativeNext: {
    id: 'product_page_carousel_alternative_next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'product_page_carousel_alternative_previous',
    defaultMessage: 'Previous',
  },
}
